module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overflow-x-auto px-5"
  }, [_c('div', {
    staticClass: "flex items-center justify-between mb-3.5"
  }, [_c('h3', {
    staticClass: "text-xl font-poppins font-semibold"
  }, [_vm._v("Students Activity")]), _vm._v(" "), _c('button', {
    staticClass: "sample bg-primary hover:bg-primary-dark text-white rounded px-4 py-2 h-9",
    on: {
      "click": function($event) {
        return _vm.handleOpenExportDataModal()
      }
    }
  }, [_vm._v("\n      Export Data\n    ")])]), _vm._v(" "), _c('table', {
    staticClass: "w-full mb-5"
  }, [_c('thead', [_c('tr', [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('td', {
    staticClass: "feedback font-semibold",
    attrs: {
      "colspan": _vm.assessmentsColspan + 2
    }
  }, [_c('div', {
    staticClass: "flex justify-center"
  }, [_vm._v("Assessment")])])]), _vm._v(" "), _c('tr', {
    staticClass: "font-semibold"
  }, [_c('td', [_c('div', {
    staticClass: "flex justify-center"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedOrderList),
      expression: "selectedOrderList"
    }],
    staticClass: "px-3 py-1.5 text-sm font-normal text-gray-700 bg-white focus:text-gray-700 cursor-pointer focus:outline-none border rounded border-blueGray",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedOrderList = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "name-asc"
    }
  }, [_vm._v("Name A-Z")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "name-desc"
    }
  }, [_vm._v("Name Z-A")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "last-name-desc"
    }
  }, [_vm._v("Last Name Z-A")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "last-name-asc"
    }
  }, [_vm._v("Last Name A-Z")])])])]), _vm._v(" "), _c('td', {
    staticClass: "tap-in cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.sortByClick('time_as_speaker')
      }
    }
  }, [_c('div', {
    staticClass: "flex items-center space-x-2"
  }, [_c('span', [_vm._v("Time as Speaker")]), _vm._v(" "), _c('i', {
    staticClass: "fa-solid",
    class: !_vm.dataTableCaretAscTime_as_speaker ?
      'fa-angle-up' :
      'fa-angle-down'
  })])]), _vm._v(" "), _c('td', {
    staticClass: "tap-in cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.sortByClick('TapInsTotal')
      }
    }
  }, [_c('div', {
    staticClass: "flex items-center space-x-2"
  }, [_c('span', [_vm._v("#Total")]), _vm._v(" "), _c('i', {
    staticClass: "fa-solid",
    class: _vm.dataTableCaretAscTapInsTotal ? 'fa-angle-up' : 'fa-angle-down'
  })])]), _vm._v(" "), _c('td', {
    staticClass: "tap-in cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.sortByClick('New_idea')
      }
    }
  }, [_c('div', {
    staticClass: "flex items-center space-x-2"
  }, [_c('span', [_vm._v("New Idea")]), _vm._v(" "), _c('i', {
    staticClass: "fa-solid",
    class: !_vm.dataTableCaretAscNewIdea ? 'fa-angle-up' : 'fa-angle-down'
  })])]), _vm._v(" "), _c('td', {
    staticClass: "tap-in cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.sortByClick('Build_on')
      }
    }
  }, [_c('div', {
    staticClass: "flex items-center space-x-2"
  }, [_c('span', [_vm._v("Build On")]), _vm._v(" "), _c('i', {
    staticClass: "fa-solid",
    class: !_vm.dataTableCaretAscBuildOn ? 'fa-angle-up' : 'fa-angle-down'
  })])]), _vm._v(" "), _c('td', {
    staticClass: "tap-in cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.sortByClick('Challenge')
      }
    }
  }, [_c('div', {
    staticClass: "flex items-center space-x-2"
  }, [_c('span', [_vm._v("Challenge")]), _vm._v(" "), _c('i', {
    staticClass: "fa-solid",
    class: !_vm.dataTableCaretAscChallenge ? 'fa-angle-up' : 'fa-angle-down'
  })])]), _vm._v(" "), _c('td', {
    staticClass: "tap-in cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.sortByClick('Question')
      }
    }
  }, [_c('div', {
    staticClass: "flex items-center space-x-2"
  }, [_c('span', [_vm._v("Question")]), _vm._v(" "), _c('i', {
    staticClass: "fa-solid",
    class: !_vm.dataTableCaretAscQuestion ? 'fa-angle-up' : 'fa-angle-down'
  })])]), _vm._v(" "), _c('td', {
    staticClass: "tap-in cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.sortByClick('Teacher')
      }
    }
  }, [_c('div', {
    staticClass: "flex items-center space-x-2"
  }, [_c('span', [_vm._v("Teacher")]), _vm._v(" "), _c('i', {
    staticClass: "fa-solid",
    class: !_vm.dataTableCaretAscTeacher ? 'fa-angle-up' : 'fa-angle-down'
  })])]), _vm._v(" "), _vm._l((_vm.assessments), function(a) {
    return _c('td', {
      key: a.title,
      staticClass: "feedback px-1"
    }, [_vm._v("\n          " + _vm._s(a.title) + "\n        ")])
  }), _vm._v(" "), _c('td', {
    staticClass: "feedback cursor-pointer px-1",
    on: {
      "click": function($event) {
        return _vm.sortByClick('TotalPoint')
      }
    }
  }, [_c('div', {
    staticClass: "flex items-center space-x-2"
  }, [_c('span', [_vm._v("Total Points")]), _vm._v(" "), _c('i', {
    staticClass: "fa-solid",
    class: !_vm.dataTableCaretAscTotalPoint ? 'fa-angle-up' : 'fa-angle-down'
  })])]), _vm._v(" "), _c('td', {
    staticClass: "feedback cursor-pointer",
    on: {
      "click": function($event) {
        return _vm.sortByClick('Feedback')
      }
    }
  }, [_c('div', {
    staticClass: "flex items-center space-x-2"
  }, [_c('span', [_vm._v("Written Feedback")]), _vm._v(" "), _c('i', {
    staticClass: "fa-solid",
    class: !_vm.dataTableCaretAscFeedback ? 'fa-angle-up' : 'fa-angle-down'
  })])])], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.data_table), function(participant, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_c('div', {
      staticClass: "flex items-center"
    }, [_c('img', {
      staticClass: "rounded-full mr-2 h-9 w-9",
      attrs: {
        "src": participant.image,
        "alt": "avatar"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "truncate",
      attrs: {
        "title": participant.name
      },
      on: {
        "click": function($event) {
          return _vm.sortByClick('StudentName')
        }
      }
    }, [_vm._v("\n              " + _vm._s(participant.name) + "\n            ")])])]), _vm._v(" "), _c('td', {
      staticClass: "tap-in"
    }, [_vm._v("\n          " + _vm._s(_vm.formatTime(participant.time_spent_as_current_speaker)) + "\n        ")]), _vm._v(" "), _c('td', {
      staticClass: "tap-in"
    }, [_vm._v(_vm._s(participant.total_contributions))]), _vm._v(" "), _c('td', {
      staticClass: "tap-in"
    }, [_vm._v(_vm._s(participant.new_idea))]), _vm._v(" "), _c('td', {
      staticClass: "tap-in"
    }, [_vm._v(_vm._s(participant.build_on))]), _vm._v(" "), _c('td', {
      staticClass: "tap-in"
    }, [_vm._v(_vm._s(participant.challenge))]), _vm._v(" "), _c('td', {
      staticClass: "tap-in"
    }, [_vm._v(_vm._s(participant.question))]), _vm._v(" "), _c('td', {
      staticClass: "tap-in"
    }, [_vm._v(_vm._s(participant.hand_raise))]), _vm._v(" "), _vm._l((_vm.assessments), function(a) {
      return (!participant.assessments.length) ? _c('td', {
        key: a.title,
        staticClass: "feedback"
      }, [_vm._v("\n          -\n        ")]) : _vm._e()
    }), _vm._v(" "), _vm._l((participant.assessments), function(s) {
      return _c('td', {
        key: s.title,
        staticClass: "feedback"
      }, [_vm._v("\n          " + _vm._s(s.value) + "\n        ")])
    }), _vm._v(" "), (!participant.assessments.length) ? _c('td', {
      staticClass: "feedback"
    }, [_vm._v("-")]) : _c('td', {
      staticClass: "feedback"
    }, [_vm._v(_vm._s(participant.total_points))]), _vm._v(" "), _c('td', {
      staticClass: "feedback"
    }, [(participant.teacher_feedback !== '') ? _c('div', {
      staticClass: "flex justify-center hover:underline text-green-500 cursor-pointer",
      on: {
        "click": function($event) {
          return _vm.redirectToStudentFeedback(participant)
        }
      }
    }, [_vm._v("\n            Sent\n          ")]) : (participant.draft_teacher_feedback !== '') ? _c('div', {
      staticClass: "flex justify-center hover:underline cursor-pointer",
      on: {
        "click": function($event) {
          return _vm.redirectToStudentFeedback(participant)
        }
      }
    }, [_vm._v("\n            Draft\n          ")]) : _c('div', {
      staticClass: "flex justify-center"
    }, [_vm._v("-")])])], 2)
  }), 0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "font-semibold cursor-pointer w-1/5"
  }, [_c('div', {
    staticClass: "flex justify-center"
  }, [_vm._v("Student Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "tap-in font-semibold",
    attrs: {
      "colspan": "7"
    }
  }, [_c('div', {
    staticClass: "flex justify-center"
  }, [_vm._v("Tap Ins")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-19fbdf46!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/measureLiveDiscussion/individualSummaryOverlay.vue
// module id = 1730
// module chunks = 61